<template>
  <div class="coupon">
    <!-- 导航条 -->
    <header>
      <span>购卡优惠</span>
      <img src="./image/btn_close@2x.png" class="btn-close" @click="confirm"/>
    </header>
    <div class="quan-item">
      <template v-if="couponList.length>0">
        <nd-item  v-for="(item,index) in couponList"
                  :key="index"
                  :index="index"
                  :activeType="getPacketDescription(item)"
                  :couponType="getPacketType(item.memberCouponType)"
                  :endTime="getValidTimeDesc(item.endTime)"
                  :money="getMoney(item)"
                  :detail="item.useDesc"
                  :unit="getUnit(item)"
                  :isSelected="item.isSelected"
                  @changeSelected="changeSelected"
                  :showSelect="true"
                  :showInfoBool="true"
                  :useTitle="title"
                  :useType="useType(item)"
        >
        </nd-item>
      </template>
      <template v-else>
        <div class="none">
          <img src="./image/img_quanbao@2x.png" class="none-img"/>
          <p class="none-content">这里空空如也...</p>
        </div>
      </template>
    </div>
    <footer>
      <!-- <span @click="jumpHistory" class="history">查看历史优惠</span> -->
      <section>
        <div class="button-list">
          <div class="left-button"><span>已优惠 ¥ {{Number(discountAmt)|currency}}</span></div>
          <div class="right-button" @click="confirm"><span>确认</span></div>
        </div>
      </section>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'coupon-select',
  props: {
    couponList: {
      type: Array,
      default: () => []
    },
    discountPrice: {
      type: Number,
      default: 0
    },
    memberGoodsGroupCd: {
      type: String,
      default: ''
    },
    memberType: {
      type: String,
      default: ''
    }
  },
  computed: {
    discountAmt () {
      let number = 0
      this.couponList.map((item = {}) => {
        const { discountAmt, isSelected } = item
        if (isSelected) {
          number = number + discountAmt
        }
      })
      return number
    },
    title () {
      return ['SC_HY', 'SC1_HY'].includes(this.memberType) ? 'SVIP优惠券' : 'VIP优惠券'
    }
  },
  methods: {
    // 卡类型
    useType (item) {
      return item.useLimitDesc
    },
    getPacketDescription (item) {
      return item.memberCouponDesc
    },
    // 选择数据变化
    changeSelected (index) {
      let { selectInd } = this.couponList[index] || {}
      if (selectInd === 'N') {
        this.$message('该优惠适用类型需与当前购买卡类型一致')
      } else {
        let couponList = this.couponList.map((item, inx) => {
          if (index === inx) {
            item.isSelected = !item.isSelected
          } else {
            item.isSelected = false
          }
          return item
        })
        this.$emit('selectCouponList', couponList)
      }
    },
    // 红包类型
    getPacketType () {
      return this.title
    },
    // 时间
    getValidTimeDesc (endTime) {
      return `红包有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
    },
    // 跳转历史优惠界面
    jumpHistory () {
      sessionStorage.setItem('couponList', JSON.stringify(this.couponList))
      this.$router.push('/quan/history')
    },
    // 金额
    getMoney (item = {}) {
      let value = ''
      let { memberCouponType, faceValue } = item
      if (memberCouponType === 'RATIO') {
        value = (faceValue * 10).toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
      } else {
        if (faceValue) {
          value = Number(faceValue).toFixed(2)
        } else {
          value = '0'
        }
      }
      return `${value}`
    },
    getUnit (item) {
      if (item.memberCouponType === 'RATIO') {
        return '折'
      } else {
        return '元'
      }
    },
    // 确认界面
    confirm () {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.coupon{
  width: 750px;
  height:100%;
  background: #FAFAFA;
  overflow: hidden;
  header{
    display: flex;
    justify-content:space-between;
    position: sticky;
    top:0;
    // background:white;
    z-index: 1002;
    align-items: center;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    padding:50px 50px 30px 30px;
    .btn-close{
      width:33px;
      height:33px;
    }
  }
  .quan-item{
    height: 100%;
    overflow: scroll;
    margin-top:18px;
    padding-bottom:450px;
  }
  .none{
    margin-top:263px;
    text-align:center;
    &-img{
      width:204px;
      height:173px;
    }
    &-content{
      margin-top:37px;
      height: 36px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
    }
  }
  footer{
    position: fixed;
    bottom:0;
    // height:320px;
    width:100%;
    text-align: center;
    background:white;
    padding-top:30px;
    .history{
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: center;
    }
    section{
      width: 750px;
      height: 172px;
      background: #FFFFFF;
      // box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
      // margin-top:38px;
      // padding-top:20px;
      .button-list{
        height:94px;
        padding:0 50px;
        display:flex;
        .left-button{
          width: 325px;
          height: 94px;
          line-height: 94px;
          background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
          border-radius: 47px 0px 0px 47px;
          >span{
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
            line-height: 45px;
          }
        }
        .right-button{
          width: 325px;
          height: 94px;
          line-height: 94px;
          background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
          border-radius: 0px 47px 47px 0px;
          >span{
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 45px;
          }
        }
      }
    }
  }
}
</style>